export default __webpack_public_path__ + "static/3-411b11c5d299abb0808d50a3737d2a35.jpeg";